import React from 'react';
import { BookOpenIcon, ArrowTopRightOnSquareIcon, PlayCircleIcon, DocumentTextIcon, ScaleIcon } from '@heroicons/react/24/outline';

const resources = [
  {
    title: 'Legal Framework Guide',
    description: 'Understanding the legal aspects of business succession',
    type: 'Legal',
    icon: ScaleIcon,
    duration: '15 min read',
  },
  {
    title: 'Financing Your Succession',
    description: 'Explore funding options and financial planning strategies',
    type: 'Financing',
    icon: DocumentTextIcon,
    duration: '20 min read',
  }
];

const SuccessionEducationCard = () => {
  return (
    <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg h-full border border-succession-border">
      <div className="px-4 py-5 sm:p-6 h-full flex flex-col">
        <div className="flex items-start gap-3">
          <div>
            <h3 className="m-0 p-0">Succession Resources</h3>
            <h4 className="text-sm text-succession-text-secondary">New to succession planning? Learn what makes a strong plan.</h4>
          </div>
        </div>

        {/* Spotlight */}
        <div className="mt-3 bg-succession-bg-secondary rounded-lg p-4 border border-succession-border">
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="font-medium text-succession-text-primary">Succession Planning Fundamentals</div>
              <div className="text-sm text-succession-text-secondary">Essential guide covering valuation, timing, and transition strategies</div>
            </div>
            <span className="text-[10px] px-2 py-1 rounded bg-succession-bg-secondary border border-succession-border text-succession-text-secondary">Featured</span>
          </div>
          <a href="/succession/education" className="mt-3 inline-flex items-center justify-center w-full px-3 py-1.5 rounded-md bg-succession-primary text-white hover:bg-succession-primary-hover text-sm">
            Start Learning
            <ArrowTopRightOnSquareIcon className="ml-2 w-4 h-4" />
          </a>
        </div>

        {/* Resources list */}
        <div className="mt-4 space-y-3">
          <div className="font-medium text-sm text-succession-text-primary">Succession Resources</div>
          {resources.map((res, idx) => (
            <a key={idx} href="/succession/education" className="flex items-center gap-3 p-3 bg-succession-bg-secondary rounded-lg border border-succession-border hover:bg-succession-hover-bg transition-theme">
              <div className="p-2 bg-succession-bg-secondary rounded">
                <res.icon className="w-4 h-4 text-succession-text-secondary" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm text-succession-text-primary truncate">{res.title}</div>
                <div className="text-xs text-succession-text-secondary truncate">{res.description}</div>
              </div>
              <div className="text-right">
                <span className="text-[10px] px-2 py-1 rounded border border-succession-border text-succession-text-secondary">{res.type}</span>
                <div className="text-xs text-succession-text-secondary mt-1">{res.duration}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-auto pt-2 flex justify-center">
          <a href="/succession/education" className="text-sm text-succession-primary hover:text-succession-primary-hover">View All Resources &gt;</a>
        </div>
      </div>
    </div>
  );
};

export default SuccessionEducationCard;


